import {
  NamedRecord,
  SelectOption,
  toSelectOption
} from '../shared/selectOptions'

export { NamedRecord, SelectOption, toSelectOption }

export interface CategoryNode {
  class_name: 'ProductCategory'
  id: number
  name: string
  ancestry: NamedRecord[]
  children: CatalogueItem[]
  file_url: string | null
  parent_id: number | null
  position: number
  batch_recipes: boolean
}

export type FeederType = 'liquid' | 'solid'
export type FeederSubtype = 'fridge' | 'standard'

export interface ProductRow {
  class_name: 'Product'
  id: number
  name: string
  product_category_id: number
  product_category_name: string | null
  group: NamedRecord | null
  unit: NamedRecord | null
  fraction: NamedRecord | null
  alergens: NamedRecord[]
  kjoul: number
  kcal: number
  file_url: string | null
  notes: string | null
  alert: number
  processing_loss: number
  position: number
  is_liquid: boolean
  volume_to_weight_multiplier: number
  feeder_type: FeederType | null
  feeder_subtype: FeederSubtype | null
  dosing_time: number | null
  simphony_external_id: string | null
  infor_external_id: string | null
  dosing_weight_step: number
  feeder_dosing_mode: NamedRecord | null
  sauce_dosing_mode: NamedRecord | null
  is_modifier: boolean | null
  infor_last_synced_at: string | null
  updated_at: string
  max_container_amount: number
}

export type CatalogueItem = CategoryNode | ProductRow

export interface CategoryOption {
  id: number
  name: string
  ancestry: NamedRecord[]
  parent_id: number | null
}

export interface ProductColumn {
  id: number
  column_name: string
  column_label: string
  class_name: string
  selected: boolean
  position: number
  mandatory: boolean
}

export interface ProductAttributeOptions {
  units: SelectOption[]
  alergens: SelectOption[]
  fractions: SelectOption[]
  feederDosingModes: SelectOption[]
  sauceDosingModes: SelectOption[]
}

export interface OrderProvider {
  provider_type: string
}

export type ItemKind = 'product' | 'category'

export interface ItemRef {
  kind: ItemKind
  id: number
}

export type Panel =
  | { kind: 'browse' }
  | { kind: 'new'; type: ItemKind }
  | { kind: 'edit'; item: ItemRef }

export interface Workspace {
  panel: Panel
  show: ItemRef | null
}

export type NoticeKind = 'success' | 'danger'

export interface Notice {
  id: number
  kind: NoticeKind
  message: string
}

export type Deletion =
  | { item: CatalogueItem; result: null }
  | { item: CatalogueItem; result: 'deleted' }
  | { item: CatalogueItem; result: 'failed'; message: string }

export type WeightUnit = 'g' | 'oz'

export type ServerErrors = Record<string, string[]>

export type SaveOutcome = { ok: true } | { ok: false; errors: ServerErrors }
